/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** ./file (ignored)
 ** module id = 15
 ** module chunks = 0
 **/